import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export abstract class DatasetDtoBase extends ItiBaseDto {
	public artifactId: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
